import { Component, HostBinding, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NodeTypeEnum } from '../../../services/eleview/types/model';
import { LabelManagerService } from '../service/label-manager.service';
import { Node } from '../../../services/eleview/types/node';
import { EditLabelService } from './edit-label.service';
import { LabelHistoryComponent, LabelHistoryDialogData } from './label-history/label-history.component';
import ace from 'ace-builds';
import { ThemeModel, ThemeService } from '../../../services/theme.service';

@Component({
	selector: 'common-edit-label',
	templateUrl: './edit-label.component.html',
	styleUrls: ['./edit-label.component.scss'],
	providers: [EditLabelService]
})
export class EditLabelComponent implements OnInit, AfterViewInit {
	@HostBinding('class.edit-label') hostClass = true;
	readonly nodeTypeCondition = NodeTypeEnum.NodeCondition;
	readonly nodeTypeAnd = NodeTypeEnum.NodeAnd;
	readonly nodeTypeOr = NodeTypeEnum.NodeOr;
	readonly nodeTypeUnknow = NodeTypeEnum.unknow;
	readonly nodeTypePlain = NodeTypeEnum.NodePlain;
	AdditionalSQL = true;
	AdditionalSQLDisplay = true;
	whereString: string;
	options: any = { maxLines: 12, printMargin: false };
	themeModel: ThemeModel;
	@ViewChild('æ ç­¾å®ä¹', { static: true })
	æ ç­¾å®ä¹: ElementRef;
	@ViewChild('labelNode', { static: false })
	labelNode: ElementRef;

	constructor(
		private theme: ThemeService,
		public dialog: MatDialog,
		private lblSvr: EditLabelService,
		public dialogRef: MatDialogRef<EditLabelComponent>,
		@Inject(MAT_DIALOG_DATA) public svr: LabelManagerService
	) {
		this.theme.theme.subscribe(v => {
			this.themeModel = v.model;
		});
	}
	ngAfterViewInit() {
		this.labelNode.nativeElement.ondragover = (event: DragEvent) => {
			// ælabelNodeåæä¸ä¸ªå®¹å¨,è½æå¥æ¡ä»¶
			event.preventDefault();
			// console.log(event);
			event.stopPropagation();
		};
	}
	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
		this.lblSvr.onNodeChange.subscribe(() => {
			if (this.svr.editLabel.Conts && this.svr.editLabel.Conts.NodeType !== NodeTypeEnum.unknow) {
				this.svr.backface
					.nodeToString(this.svr.editLabel.Conts.toInterface())
					.subscribe(str => (this.whereString = str));
			} else {
				this.whereString = '';
			}
		});
		this.lblSvr.onNodeChange.emit();
		this.æ ç­¾å®ä¹.nativeElement.parentElement.parentElement.style = 'padding:0px;';
	}
	labelDrop(event: DragEvent) {
		if (this.svr.editLabel.Conts.NodeType === this.nodeTypeUnknow) {
			this.svr.editLabel.Conts.assign(this.lblSvr.buildDragedNode());
			this.lblSvr.onNodeChange.emit();
		} else if (
			this.svr.editLabel.Conts.NodeType === this.nodeTypeAnd ||
			this.svr.editLabel.Conts.NodeType === this.nodeTypeOr
		) {
			this.svr.editLabel.Conts.Children[this.svr.editLabel.Conts.Children.length - 1].addBottomSibling(
				this.lblSvr.buildDragedNode()
			);
			if (this.lblSvr.dragData.Type === 'node') {
				(this.lblSvr.dragData.Data as Node).remove();
			}
			this.lblSvr.onNodeChange.emit();
		} else if (
			this.svr.editLabel.Conts.NodeType === this.nodeTypeCondition ||
			this.svr.editLabel.Conts.NodeType === this.nodeTypePlain
		) {
			this.svr.editLabel.Conts.addChildSibling(this.lblSvr.buildDragedNode());
			if (this.lblSvr.dragData.Type === 'node') {
				(this.lblSvr.dragData.Data as Node).remove();
			}
			this.lblSvr.onNodeChange.emit();
		}
		event.stopPropagation();
	}
	colDragStart(event: DragEvent, column: string) {
		this.lblSvr.dragData = { Type: 'column', Data: column };
	}
	openHis() {
		this.dialog.open(LabelHistoryComponent, {
			width: '296px',
			height: '384px',
			data: {
				svr: this.svr,
				data: { CategoryID: this.svr.editLabel.CategoryID, ID: this.svr.editLabel.LabelID }
			} as LabelHistoryDialogData,
			autoFocus: false
		});
	}
	acronymScroll(letter: string) {
		document.querySelector('#' + letter).scrollIntoView(true);
	}
	save() {
		this.svr.editLabel.save().subscribe(v => {
			if (v) {
				this.dialogRef.close();
			}
		});
	}
}
